:host {
  display: block;
  margin: 0.25rem;
}
.general{
  display: flex;
  .left{
    max-width: 256px;
    border-right: 1px solid lightgray;
    padding: 1em;
    img{
      width: 100%;
    }
  }
  .right{
    padding: 1em;
  }
}

.form{
  display: flex;
  flex-direction: column;
}

.controls{
  margin-top: 2em;
  display: flex;
  justify-content: flex-end;
  gap: 1em;
}

dnn-permissions-grid{
  padding: 1rem;
}